var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJava(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 114,
    viewBox: "0 0 84 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1400_41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0878 88.1268C27.0878 88.1268 22.7571 90.6557 30.1699 91.5114C39.1502 92.5402 43.74 92.3926 53.6364 90.5118C53.6364 90.5118 56.2383 92.15 59.872 93.5689C37.6868 103.116 9.66258 93.0159 27.0878 88.1268Z",
    fill: "#5382A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3768 75.6681C24.3768 75.6681 19.5194 79.2784 26.9377 80.0489C36.5308 81.0427 44.1067 81.124 57.2159 78.5893C57.2159 78.5893 59.0291 80.4351 61.8802 81.4445C35.057 89.3203 5.18078 82.0656 24.3768 75.6681Z",
    fill: "#5382A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2307 54.5338C52.6971 60.8534 45.7944 66.5402 45.7944 66.5402C45.7944 66.5402 59.6746 59.3453 53.3 50.3355C47.3464 41.9333 42.7808 37.7586 67.4973 23.3647C67.4973 23.3647 28.7006 33.0944 47.2307 54.5338Z",
    fill: "#E76F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5724 97.3421C76.5724 97.3421 79.7772 99.9937 73.0429 102.045C60.2373 105.94 19.7447 107.117 8.49605 102.2C4.45244 100.434 12.0354 97.9825 14.4206 97.4682C16.9083 96.9265 18.3299 97.0274 18.3299 97.0274C13.833 93.8465 -10.7363 103.273 5.8499 105.973C51.0828 113.339 88.3052 102.656 76.5724 97.3421Z",
    fill: "#5382A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1703 62.7594C29.1703 62.7594 8.57321 67.6717 21.8764 69.4556C27.4934 70.2107 38.6907 70.0399 49.1208 69.1624C57.6448 68.4404 66.2039 66.9052 66.2039 66.9052C66.2039 66.9052 63.1983 68.1977 61.0237 69.6887C40.1077 75.2123 -0.298106 72.6427 11.3342 66.9927C21.1717 62.2177 29.1703 62.7594 29.1703 62.7594Z",
    fill: "#5382A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1192 83.4976C87.3813 72.4034 77.5506 61.7419 70.6888 63.1783C69.007 63.5298 68.2571 63.8343 68.2571 63.8343C68.2571 63.8343 68.8815 62.8522 70.0739 62.4271C83.6487 57.635 94.0885 76.5609 65.6919 84.0567C65.6919 84.057 66.0209 83.7617 66.1192 83.4976Z",
    fill: "#5382A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3003 0.122437C53.3003 0.122437 65.0755 11.9503 42.1319 30.1383C23.7335 44.7281 37.9365 53.0468 42.1243 62.5514C31.3848 52.8217 23.5035 44.2567 28.7909 36.2851C36.5516 24.5836 58.0513 18.9103 53.3003 0.122437Z",
    fill: "#E76F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2598 113.56C51.6687 114.872 83.009 112.832 83.7512 103.136C83.7512 103.136 82.3245 106.812 66.8844 109.731C49.4649 113.023 27.9804 112.638 15.2378 110.529C15.2381 110.528 17.8464 112.697 31.2598 113.56Z",
    fill: "#5382A1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1400_41"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 114,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJava);
export default __webpack_public_path__ + "static/media/java.17cd73b2795fff3c5b19fa284d38ab82.svg";
export { ForwardRef as ReactComponent };